/* eslint-disable react-hooks/exhaustive-deps */
import { COLOR_PRIMARY, COLOR_SECONDARY, COLOR_WARNING } from 'styles/theme';
import { TOAST_MESSAGE_SEVERITY_ERROR } from 'modules/layout/types';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { showToast } from 'modules/layout/layout.actions';
import { updateHhgEstimate } from 'modules/authorizations/store/actions/houseHoldGoods.actions';
import React, { useEffect, useState } from 'react';

import {
  Box,
  Button,
  Card,
  CardContent,
  Checkbox,
  Dialog,
  DialogActions,
  Fab,
  FormControlLabel,
  Grid,
  InputAdornment,
  MenuItem,
  Select,
  Stack,
  Switch,
  TextField,
  Tooltip,
  Typography
} from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { makeStyles } from '@material-ui/styles';
import Spinner from 'modules/common/spinner.component';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { getAuthClientPoliciesListByClient, updateAuthorizationSummary } from '../store/actions/authorizations.actions';
import { UPDATE_AUTHORIZATIONS_SUCCESS } from '../store/types/authorizationTypes';
import { formatDateForInput } from 'utilities/common';
import { getDistance } from 'utilities/googleMapsClient';
import { formatMoney } from 'utilities/currencyFormatter';
import { AUTHORIZATION_FILE_STATUS_IDS } from 'modules/enumerations/enumerationIds';
import { getIntakeSummaries } from 'modules/intake/intake.actions';

// Helper to check if move type is Domestic Permanent Move
const isDomesticPermanentMove = moveTypeId => {
  return moveTypeId === 'f86bf748-1bb8-4341-ba62-9046c1262f4b'; // This is the hardcoded ID for Domestic Permanent Move in the system
};

const useStyles = makeStyles(theme => ({
  card: {
    width: '100%',
    flexGrow: 1,
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  cardContainer: {
    maxWidth: '100% !important',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  iconRow: {
    display: 'flex',
    flexDirection: 'row'
  },
  dialogIconRow: {
    display: 'flex',
    flexDirection: 'row',
    padding: '40px',
    paddingBottom: '20px'
  },
  cardDisplayContent: {
    maxWidth: '100% !important',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    margin: '10px'
  },
  chip: {
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  chipClickable: {
    cursor: 'pointer'
  },
  iconOverlayImg: {
    position: 'absolute',
    zIndex: '1 !important'
  },
  spacingX: {
    marginRight: theme.spacing(1)
  },
  footer: {
    height: 15,
    marginBottom: theme.spacing(2)
  },
  mb2: {
    marginBottom: '4px',
    marginRight: '16px'
  },
  editModalContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100% !important',
    marginLeft: '0px !important'
  },
  editModalColumn: {
    display: 'flex',
    flexDirection: 'column',
    width: '100% !important'
  },
  editModalInput: {
    minWidth: '332px'
  },
  dialogContentContainer: {
    margin: '15px',
    paddingLeft: '50px',
    paddingRight: '50px'
  },
  labelText: {
    minWidth: 350,
    marginBottom: 0
  }
}));

const HeaderCardModal = props => {
  const {
    open,
    onSubmit,
    isLoading,
    onClose,
    details,
    clientInfo,
    moveTypesEnum,
    ownershipTypesEnum,
    moveReasonsEnum,
    authorizationFileTypesEnum,
    policyOptions,
    currentMoveMiles
  } = props;
  const classes = useStyles();

  const [authorizationDetailsState, setAuthorizationDetailsState] = useState({ ...details.authorizationDetails });
  const [isDirty, setIsDirty] = useState(false);

  const moveTypes = moveTypesEnum && moveTypesEnum.length > 0 ? moveTypesEnum.filter(s => s.isActive === true) : [];
  const ownershipTypes = ownershipTypesEnum && ownershipTypesEnum.length > 0 ? ownershipTypesEnum.filter(s => s.isActive === true) : [];
  const moveReasons = moveReasonsEnum && moveReasonsEnum.length > 0 ? moveReasonsEnum.filter(s => s.isActive === true) : [];
  const authorizationFileTypes =
    authorizationFileTypesEnum && authorizationFileTypesEnum.length > 0 ? authorizationFileTypesEnum.filter(s => s.isActive === true) : [];

  const onSubmitModal = e => {
    e.preventDefault();

    onSubmit(authorizationDetailsState);
  };

  useEffect(() => {
    if (clientInfo) {
      // getClientPolicyOptions();
    }
  }, [clientInfo]);

  useEffect(() => {
    if (authorizationDetailsState) {
      if (authorizationDetailsState !== details?.authorizationDetails) {
        setIsDirty(true);
      }
    }
  }, [authorizationDetailsState]);

  const authPersonalInfo = details.familyMembers
    ? details.familyMembers.find(f => f.familyRelationshipTypeId === '83ff7cbb-6ec5-4162-a449-9205b0e5c921')
    : {};

  return (
    <Dialog open={open} fullWidth={true} maxWidth={'lg'}>
      <form onSubmit={onSubmitModal} fullScreen>
        <div className="row justify-space-between align-center">
          <div className={classes.dialogIconRow}>
            <Tooltip title="Estimates" key="Estimates" placement="right">
              <FontAwesomeIcon icon={['fas', 'money-check-dollar']} size="3x" />
            </Tooltip>
            <Typography variant="h5" sx={{ paddingLeft: '20px' }}>
              Auth Details
            </Typography>
          </div>
        </div>
        <div className={classes.dialogContentContainer}>
          <Stack
            sx={{
              width: '100%',
              minWidth: { xs: '300px', sm: '360px', md: '400px', lg: '400px' },
              gap: '1.5rem'
            }}
          >
            <Grid container spacing={2}>
              {/* File ID */}
              <Grid item md="3">
                <Box>
                  <div className={classes.mb2}>
                    <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem' }}>
                      File Number
                    </Typography>
                  </div>
                </Box>
                <Box>
                  <div className={classes.mb2}>
                    <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem' }}>
                      {details.authorizationDetails?.fileNumber ? details.authorizationDetails?.fileNumber : <div>&mdash;</div>}
                    </Typography>
                  </div>
                </Box>
              </Grid>

              {/* Client */}
              <Grid item md="3">
                <Box>
                  <div className={classes.mb2}>
                    <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem' }}>
                      Client Name
                    </Typography>
                  </div>
                </Box>
                <Box>
                  <div className={classes.mb2}>
                    <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem' }}>
                      {clientInfo && clientInfo.clientDetails ? (
                        <Link to={`/clients/${clientInfo.clientDetails.clientDetails.clientRecordId}`}>
                          {clientInfo.clientDetails.clientDetails.shortName}
                        </Link>
                      ) : (
                        <div>&mdash;</div>
                      )}
                    </Typography>
                  </div>
                </Box>
              </Grid>

              {/* Division */}
              <Grid item md="3">
                <Box>
                  <div className={classes.mb2}>
                    <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem' }}>
                      Division
                    </Typography>
                  </div>
                </Box>
                <Box>
                  <Select
                    labelId={'division'}
                    key={'division'}
                    label={''}
                    name={'division'}
                    value={authorizationDetailsState.divisionId}
                    margin="dense"
                    variant="standard"
                    sx={{ marginTop: '6px', marginBottom: '6px', width: '200px' }}
                    onChange={e => setAuthorizationDetailsState({ ...authorizationDetailsState, divisionId: e.target.value })}
                  >
                    {clientInfo.clientDetails.clientDivisions.map(opt => (
                      <MenuItem key={opt.clientDivisionId} value={opt.clientDivisionId} sx={{ margin: 'dense' }}>
                        {opt.divisionName}
                      </MenuItem>
                    ))}
                  </Select>
                </Box>
              </Grid>

              {/* EE Name */}
              <Grid item md="3">
                <Box>
                  <div className={classes.mb2}>
                    <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem' }}>
                      Full Name
                    </Typography>
                  </div>
                </Box>
                <Box>
                  <div className={classes.mb2}>
                    <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem' }}>
                      {authPersonalInfo.firstName && authPersonalInfo.lastName ? (
                        `${authPersonalInfo.firstName} ${authPersonalInfo.lastName}`
                      ) : (
                        <div>&mdash;</div>
                      )}
                    </Typography>
                  </div>
                </Box>
              </Grid>

              {/* VIP */}
              <Grid item md="3">
                <Box>
                  <div className={classes.mb2}>
                    <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem' }}>
                      VIP
                    </Typography>
                  </div>
                </Box>
                <Box>
                  <Checkbox
                    name="vip"
                    label="Active"
                    checked={authorizationDetailsState.isVIP != null ? authorizationDetailsState.isVIP : false}
                    onClick={e => setAuthorizationDetailsState({ ...authorizationDetailsState, isVIP: e.target.checked })}
                  />
                </Box>
              </Grid>

              <Grid item md="3">
                <Box>
                  <div className={classes.mb2}>
                    <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem' }}>
                      Confidential File
                    </Typography>
                  </div>
                </Box>
                <Box>
                  <Checkbox
                    name="confidentialFile"
                    label="Active"
                    checked={authorizationDetailsState.isConfidentialFile != null ? authorizationDetailsState.isConfidentialFile : false}
                    onClick={e => setAuthorizationDetailsState({ ...authorizationDetailsState, isConfidentialFile: e.target.checked })}
                  />
                </Box>
              </Grid>

              {/* Policy */}
              <Grid item md="3">
                <Box>
                  <div className={classes.mb2}>
                    <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem' }}>
                      Policy
                    </Typography>
                  </div>
                </Box>
                <Box>
                  <Select
                    labelId={'clientPolicyId'}
                    key={'clientPolicyId'}
                    label={''}
                    name={'clientPolicyId'}
                    value={authorizationDetailsState.relocationPolicyId}
                    margin="dense"
                    variant="standard"
                    sx={{ marginTop: '6px', marginBottom: '6px', width: '200px' }}
                    onChange={e => setAuthorizationDetailsState({ ...authorizationDetailsState, relocationPolicyId: e.target.value })}
                  >
                    {policyOptions.map(opt => (
                      <MenuItem key={opt.policy.relocationPolicyId} value={opt.policy.relocationPolicyId} sx={{ margin: 'dense' }}>
                        {opt.policy.policyDescription} ({opt.policy.policyCode})
                      </MenuItem>
                    ))}
                  </Select>
                </Box>
              </Grid>

              {/* Move Type */}
              <Grid item md="3">
                <Box>
                  <div className={classes.mb2}>
                    <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem' }}>
                      Move Type
                    </Typography>
                  </div>
                </Box>
                <Box>
                  <Select
                    labelId={'moveType'}
                    key={'moveType'}
                    label={''}
                    name={'moveType'}
                    value={authorizationDetailsState.moveTypeId}
                    margin="dense"
                    variant="standard"
                    sx={{ marginTop: '6px', marginBottom: '6px', width: '200px' }}
                    onChange={e => setAuthorizationDetailsState({ ...authorizationDetailsState, moveTypeId: e.target.value })}
                  >
                    {moveTypes.map(opt => (
                      <MenuItem key={opt.id} value={opt.id} sx={{ margin: 'dense' }}>
                        {opt.title}
                      </MenuItem>
                    ))}
                  </Select>
                </Box>
              </Grid>

              {/* Move Reason */}
              <Grid item md="3">
                <Box>
                  <div className={classes.mb2}>
                    <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem' }}>
                      Move Reason
                    </Typography>
                  </div>
                </Box>
                <Box>
                  <Select
                    labelId={'moveReason'}
                    key={'moveReason'}
                    label={''}
                    name={'moveReason'}
                    value={authorizationDetailsState.moveReasonId}
                    margin="dense"
                    variant="standard"
                    sx={{ marginTop: '6px', marginBottom: '6px', width: '200px' }}
                    onChange={e => setAuthorizationDetailsState({ ...authorizationDetailsState, moveReasonId: e.target.value })}
                  >
                    {moveReasons.map(opt => (
                      <MenuItem key={opt.id} value={opt.id} sx={{ margin: 'dense' }}>
                        {opt.title}
                      </MenuItem>
                    ))}
                  </Select>
                </Box>
              </Grid>

              {/* File Type */}
              <Grid item md="3">
                <Box>
                  <div className={classes.mb2}>
                    <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem' }}>
                      File Type
                    </Typography>
                  </div>
                </Box>
                <Box>
                  <Select
                    labelId={'fileType'}
                    key={'fileType'}
                    label={''}
                    name={'fileType'}
                    value={authorizationDetailsState.authorizationFileTypeId}
                    margin="dense"
                    variant="standard"
                    sx={{ marginTop: '6px', marginBottom: '6px', width: '200px' }}
                    onChange={e => setAuthorizationDetailsState({ ...authorizationDetailsState, authorizationFileTypeId: e.target.value })}
                  >
                    {authorizationFileTypes.map(opt => (
                      <MenuItem key={opt.id} value={opt.id} sx={{ margin: 'dense' }}>
                        {opt.title}
                      </MenuItem>
                    ))}
                  </Select>
                </Box>
              </Grid>

              {/* Repay Agreement fields (unchanged logic, just moved here) */}
              {policyOptions.find(option => option.policy.relocationPolicyId === authorizationDetailsState.relocationPolicyId)?.policy
                ?.isRepayAgreementRequired && (
                <>
                  <Grid item md="3">
                    <Box>
                      <div className={classes.mb2}>
                        <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem' }}>
                          Repayment Agreement Required
                        </Typography>
                      </div>
                    </Box>
                    <Box>
                      <FormControlLabel control={<Switch checked={true} disabled={true} color="primary" />} label={'Yes'} />
                    </Box>
                  </Grid>

                  <Grid item md="3">
                    <Box>
                      <div className={classes.mb2}>
                        <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem' }}>
                          Repayment Agreement Sent
                        </Typography>
                      </div>
                    </Box>
                    <Box>
                      <TextField
                        type="date"
                        name="repayAgreementSent"
                        value={
                          authorizationDetailsState.repayAgreementSent
                            ? formatDateForInput(authorizationDetailsState.repayAgreementSent)
                            : ''
                        }
                        onChange={e => {
                          const newValue = e.target.value || null;
                          setAuthorizationDetailsState(prevState => ({
                            ...prevState,
                            repayAgreementSent: newValue
                          }));
                        }}
                        fullWidth
                        variant="standard"
                        InputLabelProps={{ shrink: true }}
                        sx={{ mb: 2 }}
                      />
                    </Box>
                  </Grid>

                  <Grid item md="3">
                    <Box>
                      <div className={classes.mb2}>
                        <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem' }}>
                          Repayment Agreement Received
                        </Typography>
                      </div>
                    </Box>
                    <Box>
                      <TextField
                        type="date"
                        name="repayAgreementReceived"
                        value={
                          authorizationDetailsState.repayAgreementReceived
                            ? formatDateForInput(authorizationDetailsState.repayAgreementReceived)
                            : ''
                        }
                        onChange={e => {
                          const newValue = e.target.value || null;
                          setAuthorizationDetailsState(prevState => ({
                            ...prevState,
                            repayAgreementReceived: newValue
                          }));
                        }}
                        fullWidth
                        variant="standard"
                        InputLabelProps={{ shrink: true }}
                        sx={{ mb: 2 }}
                      />
                    </Box>
                  </Grid>
                </>
              )}

              {/* Origin Status */}
              <Grid item md="3">
                <Box>
                  <div className={classes.mb2}>
                    <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem' }}>
                      Origin Status
                    </Typography>
                  </div>
                </Box>
                <Box>
                  <Select
                    labelId={'departure'}
                    key={'departure'}
                    label={''}
                    name={'departure'}
                    value={authorizationDetailsState.departureOwnershipTypeId}
                    margin="dense"
                    variant="standard"
                    sx={{ marginTop: '6px', marginBottom: '6px', width: '200px' }}
                    onChange={e => setAuthorizationDetailsState({ ...authorizationDetailsState, departureOwnershipTypeId: e.target.value })}
                  >
                    {ownershipTypes.map(opt => (
                      <MenuItem key={opt.id} value={opt.id} sx={{ margin: 'dense' }}>
                        {opt.title}
                      </MenuItem>
                    ))}
                  </Select>
                </Box>
              </Grid>

              {/* Destination Status */}
              <Grid item md="3">
                <Box>
                  <div className={classes.mb2}>
                    <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem' }}>
                      Destination Status
                    </Typography>
                  </div>
                </Box>
                <Box>
                  <Select
                    labelId={'destination'}
                    key={'destination'}
                    label={''}
                    name={'destination'}
                    value={authorizationDetailsState.destinationOwnershipTypeId}
                    margin="dense"
                    variant="standard"
                    sx={{ marginTop: '6px', marginBottom: '6px', width: '200px' }}
                    onChange={e =>
                      setAuthorizationDetailsState({ ...authorizationDetailsState, destinationOwnershipTypeId: e.target.value })
                    }
                  >
                    {ownershipTypes.map(opt => (
                      <MenuItem key={opt.id} value={opt.id} sx={{ margin: 'dense' }}>
                        {opt.title}
                      </MenuItem>
                    ))}
                  </Select>
                </Box>
              </Grid>

              {/* Move Miles */}
              <Grid item md="3">
                <Box>
                  <div className={classes.mb2}>
                    <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem' }}>
                      Move Miles
                    </Typography>
                  </div>
                </Box>
                <Box>
                  <div className={classes.mb2}>
                    <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem' }}>
                      {currentMoveMiles}
                    </Typography>
                  </div>
                </Box>
              </Grid>

              {/* Move Cap */}
              <Grid item md="3">
                <Box>
                  <div className={classes.mb2}>
                    <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem' }}>
                      Move CAP
                    </Typography>
                  </div>
                </Box>
                <Box>
                  <TextField
                    key={'moveCap'}
                    label={''}
                    name={'moveCap'}
                    value={authorizationDetailsState.moveCap}
                    margin="dense"
                    sx={{ maxWidth: '360px' }}
                    variant="standard"
                    type="number"
                    InputProps={{
                      startAdornment: <InputAdornment position="start">$</InputAdornment>
                    }}
                    allowDecimal={true}
                    onChange={e => setAuthorizationDetailsState({ ...authorizationDetailsState, moveCap: e.target.value })}
                  />
                </Box>
              </Grid>

              {/* New header dates (row) */}
              <Grid item md="3">
                <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem' }}>
                  Init Date
                </Typography>
                <TextField
                  type="date"
                  name="initiationDate"
                  value={authorizationDetailsState.initiationDate ? formatDateForInput(authorizationDetailsState.initiationDate) : ''}
                  onChange={e => setAuthorizationDetailsState({ ...authorizationDetailsState, initiationDate: e.target.value || null })}
                  fullWidth
                  variant="standard"
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>

              <Grid item md="3">
                <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem' }}>
                  Init Call Date
                </Typography>
                <TextField
                  type="date"
                  name="initCallDate"
                  value={authorizationDetailsState.initCallDate ? formatDateForInput(authorizationDetailsState.initCallDate) : ''}
                  onChange={e => setAuthorizationDetailsState({ ...authorizationDetailsState, initCallDate: e.target.value || null })}
                  fullWidth
                  variant="standard"
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>

              <Grid item md="3">
                <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem' }}>
                  Job Start Date
                </Typography>
                <TextField
                  type="date"
                  name="newJobStartDate"
                  value={authorizationDetailsState.newJobStartDate ? formatDateForInput(authorizationDetailsState.newJobStartDate) : ''}
                  onChange={e => setAuthorizationDetailsState({ ...authorizationDetailsState, newJobStartDate: e.target.value || null })}
                  fullWidth
                  variant="standard"
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>

              {/* Estimated Start Date - Only show for non-Domestic Permanent Move */}
              {!isDomesticPermanentMove(authorizationDetailsState.moveTypeId, moveTypes) && (
                <Grid item md="3">
                  <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem' }}>
                    Estimated Start Date
                  </Typography>
                  <TextField
                    type="date"
                    name="estimatedStartDate"
                    value={
                      authorizationDetailsState.estimatedStartDate ? formatDateForInput(authorizationDetailsState.estimatedStartDate) : ''
                    }
                    onChange={e =>
                      setAuthorizationDetailsState({ ...authorizationDetailsState, estimatedStartDate: e.target.value || null })
                    }
                    fullWidth
                    variant="standard"
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
              )}

              {/* Estimated End Date - Only show for non-Domestic Permanent Move */}
              {!isDomesticPermanentMove(authorizationDetailsState.moveTypeId, moveTypes) && (
                <Grid item md="3">
                  <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem' }}>
                    Estimated End Date
                  </Typography>
                  <TextField
                    type="date"
                    name="estimatedEndDate"
                    value={authorizationDetailsState.estimatedEndDate ? formatDateForInput(authorizationDetailsState.estimatedEndDate) : ''}
                    onChange={e => setAuthorizationDetailsState({ ...authorizationDetailsState, estimatedEndDate: e.target.value || null })}
                    fullWidth
                    variant="standard"
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
              )}

              <Grid item md="3">
                <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem' }}>
                  Canceled Date
                </Typography>
                <TextField
                  type="date"
                  name="cancelledDate"
                  value={authorizationDetailsState.cancelledDate ? formatDateForInput(authorizationDetailsState.cancelledDate) : ''}
                  fullWidth
                  variant="standard"
                  InputLabelProps={{ shrink: true }}
                  disabled
                />
              </Grid>

              <Grid item md="3">
                <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem' }}>
                  Completed Date
                </Typography>
                <TextField
                  type="date"
                  name="completedDate"
                  value={authorizationDetailsState.completedDate ? formatDateForInput(authorizationDetailsState.completedDate) : ''}
                  fullWidth
                  variant="standard"
                  InputLabelProps={{ shrink: true }}
                  disabled
                />
              </Grid>

              <Grid item md="3">
                <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem' }}>
                  Ops Closed Date
                </Typography>
                <TextField
                  type="date"
                  name="opsClosedDate"
                  value={authorizationDetailsState.opsClosedDate ? formatDateForInput(authorizationDetailsState.opsClosedDate) : ''}
                  fullWidth
                  variant="standard"
                  InputLabelProps={{ shrink: true }}
                  disabled
                />
              </Grid>
            </Grid>
          </Stack>
        </div>
        {isLoading && (
          <DialogActions sx={{ p: '1.25rem' }}>
            <Spinner />
          </DialogActions>
        )}
        {!isLoading && (
          <DialogActions sx={{ p: '1.25rem' }}>
            <Button onClick={onClose}>Cancel</Button>
            <Button color="primary" type="submit" variant="contained" disabled={!isDirty}>
              Save
            </Button>
          </DialogActions>
        )}
      </form>
    </Dialog>
  );
};

const HeaderCard = props => {
  const [isLoading, setIsLoading] = useState(false);
  const [editingModalOpen, setEditingModalOpen] = useState(false);
  const [currentMoveMiles, setCurrentMoveMiles] = useState(0);

  const classes = useStyles();

  const theme = createTheme({
    palette: {
      primary: COLOR_PRIMARY,
      secondary: COLOR_SECONDARY,
      warning: COLOR_WARNING
    }
  });

  const {
    estimateInfo,
    details,
    clientInfo,
    moveTypesEnum,
    ownershipTypesEnum,
    moveReasonsEnum,
    authorizationFileTypesEnum,
    provincesEnum,
    countriesEnum,
    isReadOnly = false
  } = props;

  const [policyOptionsFull] = useState(
    clientInfo && clientInfo.clientDetails.clientRelocationPolicies ? clientInfo.clientDetails.clientRelocationPolicies : []
  );

  const moveTypes = moveTypesEnum && moveTypesEnum.length > 0 ? moveTypesEnum.filter(s => s.isActive === true) : [];
  const ownershipTypes = ownershipTypesEnum && ownershipTypesEnum.length > 0 ? ownershipTypesEnum.filter(s => s.isActive === true) : [];
  const moveReasons = moveReasonsEnum && moveReasonsEnum.length > 0 ? moveReasonsEnum.filter(s => s.isActive === true) : [];
  const authorizationFileTypes =
    authorizationFileTypesEnum && authorizationFileTypesEnum.length > 0 ? authorizationFileTypesEnum.filter(s => s.isActive === true) : [];
  const provinces = provincesEnum && provincesEnum.length > 0 ? provincesEnum.filter(s => s.isActive === true) : [];
  const countries = countriesEnum && countriesEnum.length > 0 ? countriesEnum.filter(s => s.isActive === true) : [];

  const updateFields = async values => {
    setIsLoading(true);

    const newVals = { ...values };
    if (
      values.initCallDate &&
      values.initCallDate !== '' &&
      values.initCallDate !== undefined &&
      values.authorizationFileTypeId === AUTHORIZATION_FILE_STATUS_IDS.INIT
    ) {
      newVals.authorizationFileTypeId = AUTHORIZATION_FILE_STATUS_IDS.ACTIVE;
    }
    const resp = await props.updateAuthorizationSummary(newVals);
    if (resp.type !== UPDATE_AUTHORIZATIONS_SUCCESS) {
      props.showToast('Failed to update the auth summary info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      setIsLoading(false);
      return false;
    } else {
      setIsLoading(false);
      return true;
    }
  };

  const handleSaveEdits = async values => {
    // Send update call to parent to update and refresh values.
    const resp = await updateFields(values);
    if (!resp) {
      return;
    }
    setEditingModalOpen(false); //required to exit editing mode and close modal
  };

  useEffect(() => {}, [estimateInfo]);

  useEffect(() => {
    if (clientInfo) {
      // getClientPolicyOptions();
    }
  }, [clientInfo]);

  useEffect(() => {
    const fetchDistance = async () => {
      let destAddressId = details.authorizationDetails.destinationAddressId;

      const originAddressObj =
        details && details.addresses && details.addresses.find(a => a.addressTypeId === 'aff1270e-2713-4026-a667-872ae9757825')
          ? details.addresses.find(a => a.addressTypeId === 'aff1270e-2713-4026-a667-872ae9757825')
          : {};
      const destinationAddressObj =
        destAddressId && details.addresses && details.addresses.find(a => a.addressId === destAddressId)
          ? details.addresses.find(a => a.addressId === destAddressId)
          : details && details.addresses && details.addresses.find(a => a.addressTypeId === 'c467fd82-e2d4-4d26-8827-5df0a0b5c6a5')
          ? details.addresses.find(a => a.addressTypeId === 'c467fd82-e2d4-4d26-8827-5df0a0b5c6a5')
          : {};

      const originAddress = `${originAddressObj.line1 ? originAddressObj.line1 + ', ' : ''}${
        originAddressObj.city ? originAddressObj.city + ', ' : ''
      }${provinces ? provinces.find(p => p.id === originAddressObj.provinceId)?.title + ', ' : ''}${
        countries ? countries.find(c => c.id === originAddressObj.countryId)?.title : ''
      }`;
      const destinationAddress = `${destinationAddressObj.line1 ? destinationAddressObj.line1 + ', ' : ''}${
        destinationAddressObj.city ? destinationAddressObj.city + ', ' : ''
      }${provinces ? provinces.find(p => p.id === destinationAddressObj.provinceId)?.title + ', ' : ''}${
        countries ? countries.find(c => c.id === destinationAddressObj.countryId)?.title : ''
      }`;
      const distance = await getDistance({ formattedAddress: originAddress }, { formattedAddress: destinationAddress });
      setCurrentMoveMiles(distance.text);
    };
    fetchDistance();
  }, [details]);

  let destAddressId = details.authorizationDetails.destinationAddressId;

  const originAddress =
    details && details.addresses && details.addresses.find(a => a.addressTypeId === 'aff1270e-2713-4026-a667-872ae9757825')
      ? details.addresses.find(a => a.addressTypeId === 'aff1270e-2713-4026-a667-872ae9757825')
      : {};

  const destinationAddress =
    destAddressId && details.addresses && details.addresses.find(a => a.addressId === destAddressId)
      ? details.addresses.find(a => a.addressId === destAddressId)
      : details && details.addresses && details.addresses.find(a => a.addressTypeId === 'c467fd82-e2d4-4d26-8827-5df0a0b5c6a5')
      ? details.addresses.find(a => a.addressTypeId === 'c467fd82-e2d4-4d26-8827-5df0a0b5c6a5')
      : {};

  const authPersonalInfo =
    details.familyMembers && details.familyMembers.find(f => f.familyRelationshipTypeId === '83ff7cbb-6ec5-4162-a449-9205b0e5c921')
      ? details.familyMembers.find(f => f.familyRelationshipTypeId === '83ff7cbb-6ec5-4162-a449-9205b0e5c921')
      : {};

  const highlighted =
    details && details.authorizationDetails && (details.authorizationDetails.isVIP || details.authorizationDetails.isConfidentialFile);

  return (
    <ThemeProvider theme={theme}>
      <Card className={classes.card} sx={{ border: highlighted ? '5px solid #f0b11d' : '' }}>
        <Box>
          <CardContent sx={{ padding: '10px', marginLeft: '30px' }}>
            <Grid container spacing={1} columns={19}>
              {/* 1) File ID */}
              <Grid item md="2">
                <Box>
                  <div className={classes.mb2}>
                    <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400 }}>
                      File Number
                    </Typography>
                  </div>
                </Box>
                <Box>
                  <div className={classes.mb2}>
                    <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500 }}>
                      {details.authorizationDetails.fileNumber ? details.authorizationDetails.fileNumber : <div>&mdash;</div>}
                    </Typography>
                  </div>
                </Box>
              </Grid>

              {/* 2) Client */}
              <Grid item md="2">
                <Box>
                  <div className={classes.mb2}>
                    <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400 }}>
                      Client Name
                    </Typography>
                  </div>
                </Box>
                <Box>
                  <div className={classes.mb2}>
                    <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500 }}>
                      {clientInfo ? (
                        <Link to={`/clients/${clientInfo.clientDetails.clientDetails.clientRecordId}`}>
                          {clientInfo.clientDetails.clientDetails.shortName}
                        </Link>
                      ) : (
                        <div>&mdash;</div>
                      )}
                    </Typography>
                  </div>
                </Box>
              </Grid>

              {/* 3) Division */}
              <Grid item md="2">
                <Box>
                  <div className={classes.mb2}>
                    <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400 }}>
                      Division
                    </Typography>
                  </div>
                </Box>
                <Box>
                  <div className={classes.mb2}>
                    <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500 }}>
                      {clientInfo ? (
                        clientInfo.clientDetails.clientDivisions.find(d => d.clientDivisionId === details.authorizationDetails.divisionId)
                          ?.divisionName
                      ) : (
                        <div>&mdash;</div>
                      )}
                    </Typography>
                  </div>
                </Box>
              </Grid>

              {/* 4) EE Name */}
              <Grid item md="2">
                <Box>
                  <div className={classes.mb2}>
                    <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400 }}>
                      Full Name
                    </Typography>
                  </div>
                </Box>
                <Box>
                  <div className={classes.mb2}>
                    <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500 }}>
                      {authPersonalInfo.firstName && authPersonalInfo.lastName ? (
                        `${authPersonalInfo.firstName} ${authPersonalInfo.lastName}`
                      ) : (
                        <div>&mdash;</div>
                      )}
                    </Typography>
                  </div>
                </Box>
              </Grid>

              {/* 5) VIP */}
              <Grid item md="2">
                <Box>
                  <div className={classes.mb2}>
                    <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400 }}>
                      VIP
                    </Typography>
                  </div>
                </Box>
                <Box>
                  <div className={classes.mb2}>
                    <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500 }}>
                      {details.authorizationDetails.isVIP ? 'Yes' : 'No'}
                    </Typography>
                  </div>
                </Box>
              </Grid>

              <Grid item md="2">
                <Box>
                  <div className={classes.mb2}>
                    <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400 }}>
                      Confidential File
                    </Typography>
                  </div>
                </Box>
                <Box>
                  <div className={classes.mb2}>
                    <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500 }}>
                      {details.authorizationDetails.isConfidentialFile ? 'Yes' : 'No'}
                    </Typography>
                  </div>
                </Box>
              </Grid>

              {/* 6) Policy */}
              <Grid item md="2">
                <Box>
                  <div className={classes.mb2}>
                    <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400 }}>
                      Policy
                    </Typography>
                  </div>
                </Box>
                <Box>
                  <div className={classes.mb2}>
                    <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500 }}>
                      {policyOptionsFull &&
                      details.authorizationDetails.relocationPolicyId &&
                      policyOptionsFull.find(po => po.policy.relocationPolicyId === details.authorizationDetails.relocationPolicyId) ? (
                        `${
                          policyOptionsFull.find(po => po.policy.relocationPolicyId === details.authorizationDetails.relocationPolicyId)
                            .policy.policyDescription
                        } (${
                          policyOptionsFull.find(po => po.policy.relocationPolicyId === details.authorizationDetails.relocationPolicyId)
                            .policy.policyCode
                        })`
                      ) : (
                        <div>&mdash;</div>
                      )}
                    </Typography>
                  </div>
                </Box>
              </Grid>

              {/* 7) Move Type */}
              <Grid item md="2">
                <Box>
                  <div className={classes.mb2}>
                    <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400 }}>
                      Move Type
                    </Typography>
                  </div>
                </Box>
                <Box>
                  <div className={classes.mb2}>
                    <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500 }}>
                      {details.authorizationDetails.moveTypeId ? (
                        moveTypes.find(mt => mt.id === details.authorizationDetails.moveTypeId).title
                      ) : (
                        <div>&mdash;</div>
                      )}
                    </Typography>
                  </div>
                </Box>
              </Grid>

              {/* 8) Move Reason */}
              <Grid item md="2">
                <Box>
                  <div className={classes.mb2}>
                    <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400 }}>
                      Move Reason
                    </Typography>
                  </div>
                </Box>
                <Box>
                  <div className={classes.mb2}>
                    <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500 }}>
                      {details.authorizationDetails.moveReasonId ? (
                        moveReasons.find(mr => mr.id === details.authorizationDetails.moveReasonId).title
                      ) : (
                        <div>&mdash;</div>
                      )}
                    </Typography>
                  </div>
                </Box>
              </Grid>

              {/* Edit button (keep near top/right) */}
              <Grid item md="1">
                {!isReadOnly && (
                  <div className="row justify-space-between align-center" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Fab className={classes.iconOverlayImg} color="primary" size="small" onClick={() => setEditingModalOpen(true)}>
                      <FontAwesomeIcon size="1x" icon={['fas', 'pen']} color={theme.palette.common.white} />
                    </Fab>
                  </div>
                )}
              </Grid>

              {/* 9) File Type */}
              <Grid item md="2">
                <Box>
                  <div className={classes.mb2}>
                    <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400 }}>
                      File Type
                    </Typography>
                  </div>
                </Box>
                <Box>
                  <div className={classes.mb2}>
                    <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500 }}>
                      {details.authorizationDetails.authorizationFileTypeId ? (
                        authorizationFileTypes.find(aft => aft.id === details.authorizationDetails.authorizationFileTypeId).title
                      ) : (
                        <div>&mdash;</div>
                      )}
                    </Typography>
                  </div>
                </Box>
              </Grid>

              {/* 10) Repay Agreement */}
              <Grid item md="2" sx={{ display: 'flex', justifyContent: 'center', ml: '-10px' }}>
                <Box
                  sx={{
                    backgroundColor: details.authorizationDetails.repayAgreementReceived
                      ? '#b2d8bd'
                      : policyOptionsFull.find(
                          option => option.policy.relocationPolicyId === details.authorizationDetails.relocationPolicyId
                        )?.policy?.isRepayAgreementRequired
                      ? '#f5b5aa'
                      : '#e0e0e0',
                    borderRadius: '4px',
                    padding: '3px 4px',
                    display: 'inline-block'
                  }}
                >
                  <Box>
                    <div className={classes.mb2}>
                      <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400 }}>
                        Repay Agreement
                      </Typography>
                    </div>
                  </Box>
                  <Box>
                    <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500 }}>
                      {policyOptionsFull.find(
                        option => option.policy.relocationPolicyId === details.authorizationDetails.relocationPolicyId
                      )?.policy?.isRepayAgreementRequired
                        ? 'Required'
                        : 'Not Required'}
                    </Typography>
                  </Box>
                </Box>
              </Grid>

              {/* 11) Origin */}
              <Grid item md="2" sx={{ ml: '10px' }}>
                <Box>
                  <div className={classes.mb2}>
                    <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400 }}>
                      Origin
                    </Typography>
                  </div>
                </Box>
                <Box>
                  <div className={classes.mb2}>
                    <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500 }}>
                      {originAddress ? (
                        `${originAddress.city}, ${provinces ? provinces.find(p => p.id === originAddress.provinceId)?.title : ''}`
                      ) : (
                        <div>&mdash;</div>
                      )}
                    </Typography>
                  </div>
                </Box>
              </Grid>

              {/* 12) Origin Status */}
              <Grid item md="2">
                <Box>
                  <div className={classes.mb2}>
                    <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400 }}>
                      Origin Status
                    </Typography>
                  </div>
                </Box>
                <Box>
                  <div className={classes.mb2}>
                    <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500 }}>
                      {details.authorizationDetails.departureOwnershipTypeId ? (
                        ownershipTypes.find(at => at.id === details.authorizationDetails.departureOwnershipTypeId).title
                      ) : (
                        <div>&mdash;</div>
                      )}
                    </Typography>
                  </div>
                </Box>
              </Grid>

              {/* 13) Destination */}
              <Grid item md="2">
                <Box>
                  <div className={classes.mb2}>
                    <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400 }}>
                      Destination
                    </Typography>
                  </div>
                </Box>
                <Box>
                  <div className={classes.mb2}>
                    <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500 }}>
                      {destinationAddress ? (
                        `${destinationAddress.city}, ${provinces ? provinces.find(p => p.id === destinationAddress.provinceId)?.title : ''}`
                      ) : (
                        <div>&mdash;</div>
                      )}
                    </Typography>
                  </div>
                </Box>
              </Grid>

              {/* 14) Dest Status */}
              <Grid item md="2">
                <Box>
                  <div className={classes.mb2}>
                    <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400 }}>
                      Destination Status
                    </Typography>
                  </div>
                </Box>
                <Box>
                  <div className={classes.mb2}>
                    <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500 }}>
                      {details.authorizationDetails.destinationOwnershipTypeId ? (
                        ownershipTypes.find(at => at.id === details.authorizationDetails.destinationOwnershipTypeId).title
                      ) : (
                        <div>&mdash;</div>
                      )}
                    </Typography>
                  </div>
                </Box>
              </Grid>

              {/* 15) Move Miles */}
              <Grid item md="2">
                <Box>
                  <div className={classes.mb2}>
                    <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400 }}>
                      Move Miles
                    </Typography>
                  </div>
                </Box>
                <Box>
                  <div className={classes.mb2}>
                    <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500 }}>
                      {currentMoveMiles}
                    </Typography>
                  </div>
                </Box>
              </Grid>

              {/* 16) Move Cap */}
              <Grid item md="2">
                <Box>
                  <div className={classes.mb2}>
                    <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400 }}>
                      Move CAP
                    </Typography>
                  </div>
                </Box>
                <Box>
                  <div className={classes.mb2}>
                    <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500 }}>
                      {details.authorizationDetails.moveCap ? formatMoney(details.authorizationDetails.moveCap) : <div>&mdash;</div>}
                    </Typography>
                  </div>
                </Box>
              </Grid>

              <Grid item md={2}>
                <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400 }}>
                  Init Date
                </Typography>
                <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500 }}>
                  {details.authorizationDetails.initiationDate ? (
                    formatDateForInput(details.authorizationDetails.initiationDate)
                  ) : (
                    <div>&mdash;</div>
                  )}
                </Typography>
              </Grid>

              <Grid item md={2} sx={{ ml: '0px' }}>
                <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400 }}>
                  Init Call Date
                </Typography>
                <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500 }}>
                  {details.authorizationDetails.initCallDate ? (
                    formatDateForInput(details.authorizationDetails.initCallDate)
                  ) : (
                    <div>&mdash;</div>
                  )}
                </Typography>
              </Grid>

              <Grid item md={2} sx={{ ml: '0px' }}>
                <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400 }}>
                  Job Start Date
                </Typography>
                <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500 }}>
                  {details.authorizationDetails.newJobStartDate ? (
                    formatDateForInput(details.authorizationDetails.newJobStartDate)
                  ) : (
                    <div>&mdash;</div>
                  )}
                </Typography>
              </Grid>

              {/* Estimated Start Date - Only show for non-Domestic Permanent Move */}
              {!isDomesticPermanentMove(details.authorizationDetails.moveTypeId, moveTypes) && (
                <Grid item md={2}>
                  <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400 }}>
                    Estimated Start Date
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500 }}>
                    {details.authorizationDetails.estimatedStartDate ? (
                      formatDateForInput(details.authorizationDetails.estimatedStartDate)
                    ) : (
                      <div>&mdash;</div>
                    )}
                  </Typography>
                </Grid>
              )}

              {/* Estimated End Date - Only show for non-Domestic Permanent Move */}
              {!isDomesticPermanentMove(details.authorizationDetails.moveTypeId, moveTypes) && (
                <Grid item md={2}>
                  <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400 }}>
                    Estimated End Date
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500 }}>
                    {details.authorizationDetails.estimatedEndDate ? (
                      formatDateForInput(details.authorizationDetails.estimatedEndDate)
                    ) : (
                      <div>&mdash;</div>
                    )}
                  </Typography>
                </Grid>
              )}

              <Grid item md={2}>
                <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400 }}>
                  Canceled Date
                </Typography>
                <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500 }}>
                  {details.authorizationDetails.cancelledDate ? (
                    formatDateForInput(details.authorizationDetails.cancelledDate)
                  ) : (
                    <div>&mdash;</div>
                  )}
                </Typography>
              </Grid>

              <Grid item md={2}>
                <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400 }}>
                  Completed Date
                </Typography>
                <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500 }}>
                  {details.authorizationDetails.completedDate ? (
                    formatDateForInput(details.authorizationDetails.completedDate)
                  ) : (
                    <div>&mdash;</div>
                  )}
                </Typography>
              </Grid>

              <Grid item md={2}>
                <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400 }}>
                  Ops Closed Date
                </Typography>
                <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500 }}>
                  {details.authorizationDetails.opsClosedDate ? (
                    formatDateForInput(details.authorizationDetails.opsClosedDate)
                  ) : (
                    <div>&mdash;</div>
                  )}
                </Typography>
              </Grid>

              <Grid item md={2}>
                <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400 }}>
                  Intake Record
                </Typography>
                <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500 }}>
                  <Link to={`/intakeRecords/${details.authorizationDetails.intakeRecordId}?returnId=${props.id}`}>View Intake Record</Link>
                </Typography>
              </Grid>
            </Grid>
          </CardContent>
        </Box>
      </Card>
      {editingModalOpen && (
        <HeaderCardModal
          classes={classes}
          tab={0}
          open={editingModalOpen}
          isLoading={isLoading}
          onClose={() => setEditingModalOpen(false)}
          onSubmit={handleSaveEdits}
          estimateInfo={estimateInfo}
          details={details}
          clientInfo={clientInfo}
          moveTypesEnum={moveTypesEnum}
          ownershipTypesEnum={ownershipTypesEnum}
          moveReasonsEnum={moveReasonsEnum}
          authorizationFileTypesEnum={authorizationFileTypesEnum}
          provincesEnum={provincesEnum}
          policyOptions={policyOptionsFull}
          currentMoveMiles={currentMoveMiles}
        />
      )}
    </ThemeProvider>
  );
};

const mapStateToProps = state => {
  const { moveTypes, moveReasons, authorizationFileTypes, provinces, ownershipTypes, countries } = state.enumerations.allEnums;

  return {
    moveTypesEnum: moveTypes,
    moveReasonsEnum: moveReasons,
    authorizationFileTypesEnum: authorizationFileTypes,
    provincesEnum: provinces,
    ownershipTypesEnum: ownershipTypes,
    countriesEnum: countries,
    intakeSummaries: state.intake?.intakeSummaries || null
  };
};

export default compose(
  connect(mapStateToProps, {
    updateHhgEstimate,
    getAuthClientPoliciesListByClient,
    updateAuthorizationSummary,
    showToast,
    getIntakeSummaries
  })
)(HeaderCard);
